import { faAngleLeft, faAngleRight, faSync } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button, Grid, Typography, withStyles } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import clsx from 'clsx';
import moment from 'moment';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DateFnsFormats, formatAs, getCurrentUkgUserDateTime, getDstOffset, removeUkgUserTimeZoneTransformation } from '../../../../common-client2/src/services/ukgDateTime';
import SideBar from '../../../../common/components/UI/SideBar/SideBar';
import Snackbar from '../../../../common/components/UI/Snackbar/Snackbar';
import * as Utils from '../../../utils';
import { getMonthWeekRange } from '../Utils/momentHelper';
import {
    clearSelectedOpenShifts,
    clearSelectedShifts,
    selectOpenShift,
    selectShift,
    updateDateRange,
    updateEmployeeDashboardData,
    updateEmployeeToOfferList,
    updateFilterList,
    updateLoading,
    appendManagerSettings,
    clearManagerSettings,
    updateSelectedActionIndex,
    updateSidePanelData,
    updateSnackbar,
    updateValidProposalShifts,
} from "../../actions";
import Calendar from '../Calendar/calendar';
import * as Net from '../Utils/dotNet';
import { generateSelectedPartialLabel } from '../Utils/PartialShiftHelper';
import PanelContainer from './DesktopPanelContainer';
import SidePanel from './sidePanel';
// Component imports
import SplitButton from '../../../../common/components/UI/SplitButton/SplitButton';
import TopBar from '../../../../common/components/UI/TopBar/topBar';
import * as aux from '../../../auxilaries';
import { ongoingRequestStatuses, } from '../../../constants';
import {
    BillboardViewType,
    RequestSource, RequestStatus,
    RequestSubtypes,
    RequestTypes, TypeOfPeriod,
} from '../../../Enums';
import { EmployeeDashboardStyles } from '../../../styles/styles';
import { employeeDashboardStore as store } from '../../../store';
import NotificationList from '../../components/NotificationList';
import { getSettingsOfExistingOffersBlockingNewRequest } from '../Utils/CalendarHelper';
import * as Handlers from '../Utils/handlers';
import * as UI from '../Utils/uiGenerators';
import BillboardListView from './BillboardListView';


const BillboardContainer = styled.div`
    width: calc(100% - ${props => (props.open ? "320px" : "0px")});
    padding-left: ${props => props.open ? "15px" : '0px'};
    transition: all 0.3s ease-out;
    height: "100%";
`;

const CALENDAR_VIEW_OPTIONS = [{
    label: 'Weekly',
    value: BillboardViewType.Calendar,
    disabled: false,
    visibleWeeksCount: 1
},
{
    label: 'Monthly',
    value: BillboardViewType.Calendar,
    disabled: false,
    visibleWeeksCount: undefined
},
{
    label: 'List',
    value: BillboardViewType.List,
    disabled: false,
    visibleWeeksCount: undefined
}]

class EmployeeDashboard extends Component {
    calendarRef = React.createRef();
    actionButtonRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            privateOffers: [],
            shiftsSelected: [],
            employeesSelected: [],
            employeesSearch: undefined,
            showSidePanel: false,
            periods: [],
            open: false,
            currentMonth: moment.utc(),
            currentView: CALENDAR_VIEW_OPTIONS.find(x => x.label === "Monthly"),
            billboardActions: [],
            openActionOptions: false,
            selectedActionIndex: -1,
            openSubmitActionOptions: false,
            calendarViewOptions: CALENDAR_VIEW_OPTIONS,
            validProposalShifts: [],
            openCalendarViewOptions: false,
            selectedCalendarIndex: 1,
            tabSelected: 0,
            userCurrentOffset: getDstOffset(new Date(), new Date().getFullYear(), false) * 60
        };
    }

    componentDidMount = () => {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount = () => {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.state.openActionOptions && 
            this.actionButtonRef.current && 
            !this.actionButtonRef.current.contains(event.target)) {
            this.handleActionOptionClose();
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (
            prevState.currentView.value !== this.state.currentView.value &&
            this.state.currentView.value === BillboardViewType.Calendar &&
            this.calendarRef.current
        ) {
            const calendarInstance = this.calendarRef.current.getInstance?.();
            if (calendarInstance) {
                calendarInstance.setDate(this.state.currentMonth.toDate());
            }
        }

        if (prevProps.shiftsLoaded !== this.props.shiftsLoaded && this.props.shiftsLoaded) {
            // When shifts load, generate calendar filters with empty manager settings
            // This allows the calendar to render shifts immediately
            this.props.generateCalendarDefinitionAndFilters([], this.props.storeData.monthlySchedule);

            if (this.calendarRef.current) {
                const calendarInstance = this.calendarRef.current.getInstance?.();
                if (calendarInstance) {
                    calendarInstance.render();
                }
            }
        }

        if (prevProps.managerSettingsLoaded !== this.props.managerSettingsLoaded && this.props.managerSettingsLoaded) {
            // When manager settings load, just refresh the UI state (billboard actions, filters)
            // No need to call refreshData since loadMonthData is already called in parallel in getInitData
            this.refreshManagerSettings()
        }
    }

    a11yProps = (index) => ({
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    })

    handleChange = (event, newValue) => {
        this.setState({
            tabSelected: newValue,
        })
    }

    //TODO - not used?? remove??
    handleSubmitActionType = (selected) => {
        const { billboardActions } = this.state
        const { updateSelectedActionIndex } = this.props
        let index = billboardActions.findIndex(ele => ele.value === selected.value)
        updateSelectedActionIndex(index)
        this.setState({
            openSubmitActionOptions: false,
        })
    }

    handleOpenActionType = async (event, index, filteredList, fullList) => {
        let settingInFullListIndex = fullList.findIndex(x => x.value === filteredList[index].value);
        await this.props.updateSelectedActionIndex(settingInFullListIndex)
        this.handleActionOptionClose()
        this.handleActionRequest()
    }

    handleActionOptionToggle = () => {
        const { t } = this.props;
        if (this.state.billboardActions.length === 0) {
            this.handleSnackbar('error', t('billboard.noRequestsAvailable'), true);
            return;
        }
        this.setState({
            openActionOptions: !this.state.openActionOptions
        })
    }

    handleActionOptionClose = () => {
        this.setState({
            openActionOptions: false
        })
    }

    handleActionRequest = async () => {
        const { billboardActions } = this.state;
        const { selectedShifts, selectedOpenShifts, managerSettings, person, updateSidePanelData, selectedActionIndex } = this.props;

        if (selectedActionIndex < 0) {
            // Break out if the action is the placeholder
            this.handleSnackbar('error', 'Select an action', true)
            return
        }
        if (selectedShifts.length <= 0 && selectedOpenShifts.length <= 0) {
            return
        }
        let data = {
            shifts: []
        };
        let orgJob = Utils.parseJobAndLocation(person.primaryJob);
        let selectedManagerSetting = managerSettings.find(setting => setting.id === billboardActions[selectedActionIndex].value)
        if (selectedManagerSetting.type === RequestTypes.openShift) {
            const openShifts = selectedOpenShifts
            data.type = RequestTypes.openShift
            data.label = 'Employee Request'
            data.location = orgJob.location;
            data.job = orgJob.job;
            data.source = RequestSource.Requester
            for (let openShift of openShifts) {
                data.shifts = [...data.shifts, openShift.shifts[0]]
            }
            data.raw = openShifts
            updateSidePanelData(data)
        } else {
            data.type = -1;
            data.label = 'Employee Request';
            data.employeeName = person.personName;
            data.location = orgJob.location;
            data.job = orgJob.job;
            for (let shift of selectedShifts) {
                data.shifts = [...data.shifts, shift]
            }
            updateSidePanelData(data)
            this.props.updateLoading(false)
        }

    }

    handleCalendarType = (event, index) => {
        let selected = this.state.calendarViewOptions[index];
        let filterPanelOpenState = null;
        if (selected.value === BillboardViewType.List) {
            filterPanelOpenState = {
                open: false
            };
        }
        this.setState({
            selectedCalendarIndex: index,
            openCalendarViewOptions: false,
            currentView: selected,
            ...filterPanelOpenState,
        })
        //this.handleCalendarView(selected.value)
    }

    handleCalendarViewOptionToggle = () => {
        this.setState({
            openCalendarViewOptions: !this.state.openCalendarViewOptions
        })
    }

    handleCalendarViewOptionClose = () => {
        this.setState({
            openCalendarViewOptions: false
        })
    }

    closeSidePanel = () => {
        this.setState({
            shiftsSelected: [],
            employeesSelected: [], // Reset employees selected
            showSidePanel: false,
            showNotificationPanel: false,
            employeesSearch: undefined,
        })
        this.refreshManagerSettings()
    }

    handleViewButton = (offerId, proposalId = null, isOwnOffer = false) => {
        const { storeData, updateLoading } = this.props

        updateLoading(true)
        let privateOffer = storeData.privateOffers.find(ele => ele.offerId === offerId);
        Handlers.markAsViewed.bind(this)(privateOffer.requestType, offerId, proposalId)
        updateLoading(false)

        // Create a pseudo schedule object
        let raw = {
            ...privateOffer,
            source: (isOwnOffer) ? RequestSource.Offerer : RequestSource.Requester,
            offerorEmployeeId: privateOffer.employeeFromId,
            offerorEmployeeName: privateOffer.employeeFromName,
            offerorEmployeePrimaryJob: privateOffer.employeeFromPrimaryJob,
            isPrivate: true
        }

        this.handleShiftClick(
            {
                schedule: {
                    raw: raw,
                    isBackendRequestBodyStillCorrect: true,
                }
            }, true
        )
    }

    handleMultiSelectOpenShift = schedule => {
        const { managerSettings, selectedShifts, selectedOpenShifts, updateSelectedActionIndex } = this.props
        const { userCurrentOffset } = this.state;
        if (selectedShifts.length > 0) {
            this.handleSnackbar('error', 'Cannot select an open shift in this selection', true)
            return
        }
        if (selectedOpenShifts.length > 0 && selectedOpenShifts[0].managerSettingId !== schedule.raw.managerSettingId) {
            this.handleSnackbar('error', 'Cannot select this open shift in this selection', true)
            return
        }
        let error = { exists: false, message: '' };

        let startDate = moment.utc(schedule.raw.startDate);

        const validSetting = managerSettings.find((setting) => (
            (setting.type === RequestTypes.openShift && setting.requestPeriod_TypeOfPeriod === TypeOfPeriod.Forever) ||
            moment.utc(startDate).isBetween(moment.utc(setting.requestPeriod_StartDate), moment.utc(setting.requestPeriod_EndDate), null, '[]')
        ));

        if (!validSetting) {
            error = { exists: true, message: 'Cannot request open shift outside a request period' };
        }
        if (error.exists) {
            this.handleSnackbar('error', error.message, true)
        } else {

            new Promise((resolve, reject) => {
                this.props.selectOpenShift(schedule.raw)
                resolve()
            }).then(() => {
                let { selectedOpenShifts } = this.props
                let filteredManagerSettings = managerSettings
                if (selectedOpenShifts.length > 0) {
                    for (const shift of selectedOpenShifts) {
                        filteredManagerSettings = filteredManagerSettings.filter(setting => setting.isVisible
                            && (
                                setting.requestPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                                || moment.utc(shift.startDate).isBetween(moment.utc(setting.requestPeriod_StartDate), moment.utc(setting.requestPeriod_EndDate), null, '[]')
                            )
                            && (
                                setting.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                                || moment.utc().add(userCurrentOffset, 'm').isBetween(moment.utc(setting.toCoverPeriod_StartDate), moment.utc(setting.toCoverPeriod_EndDate), null, '[]')
                            )
                            && setting.type === RequestTypes.openShift
                            && setting.id === selectedOpenShifts[0].managerSettingId
                        )
                    }
                }
                else {
                    filteredManagerSettings = filteredManagerSettings.filter(setting => setting.isVisible &&
                        (
                            setting.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                            || moment.utc().add(userCurrentOffset, 'm').isBetween(moment.utc(setting.toCoverPeriod_StartDate), moment.utc(setting.toCoverPeriod_EndDate), null, '[]')
                        )
                        && ![RequestTypes.openShift, RequestTypes.voluntaryTimeOff].includes(setting.type)
                    )
                }

                updateSelectedActionIndex(-1);
                this.setState({
                    billboardActions: UI.generateBillboardActions(filteredManagerSettings),
                })
            })
        }
    }

    handleMultiSelectShift = (schedule) => {
        const { billboardActions, userCurrentOffset } = this.state;
        const { selectShift, selectedShifts, selectedOpenShifts, managerSettings, selectedActionIndex, t, storeData } = this.props
        let error = { exists: false, message: '' };

        if (selectedOpenShifts.length > 0) {
            this.handleSnackbar('error', 'Cannot select a shift in this selection', true)
            return
        }

        const currentTime = getCurrentUkgUserDateTime(new Date()).toISOString();
        const shiftStartTime = new Date(schedule.raw.startDateTime);
        const hasShiftStarted = schedule.raw.startDateTime < currentTime;
        const hasShiftEnded = schedule.raw.endDateTime < currentTime;
        const isShiftInProgress = hasShiftStarted && !hasShiftEnded;
        const validManagerSettingsAfterShiftStart = managerSettings.filter(x => Utils.isValidSettingAfterShiftStart(x, shiftStartTime));
        if (hasShiftEnded || (isShiftInProgress && !validManagerSettingsAfterShiftStart.length) && schedule.calendarId === "0") {
            this.handleSnackbar('error', 'Shift is in the past', true)
            return;
        }

        const newRequestBlockedResult = getSettingsOfExistingOffersBlockingNewRequest(storeData, schedule.id, false);
        if (newRequestBlockedResult.isNewRequestBlocked) {
            error = UI.generateMultiSettingActionErrorMessage(newRequestBlockedResult.blockingManagerAggregateRootIds, managerSettings);
        }

        else {
            // Validates if there's at least 1 valid setting with the selection before updating the state
            let filteredManagerSettings = [];
            let startDate = moment.utc(schedule.raw.startDateTime);
            if (billboardActions && billboardActions.length) {
                for (const action of billboardActions) {
                    let setting = managerSettings.find(setting => setting.id === action.value
                        && ![RequestTypes.openShift, RequestTypes.voluntaryTimeOff].includes(setting.type));
                    if (setting) {
                        filteredManagerSettings.push(setting);
                    }
                }
            } else {
                filteredManagerSettings = managerSettings;
            }

            if (isShiftInProgress) {
                const validManagerSettingsAfterShiftStartIds = validManagerSettingsAfterShiftStart.map(x => x.id);
                filteredManagerSettings = filteredManagerSettings.filter(x => validManagerSettingsAfterShiftStartIds.includes(x.id));
            }
            filteredManagerSettings = Utils.getValidManagerSettings(filteredManagerSettings, [schedule.raw]);

            let validSetting = filteredManagerSettings.find(setting =>

                (setting.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                    || moment.utc().add(userCurrentOffset, 'm').isBetween(moment.utc(setting.toCoverPeriod_StartDate), moment.utc(setting.toCoverPeriod_EndDate), null, '[]'))
                && (
                    setting.requestPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                    || moment.utc(startDate).isBetween(moment.utc(setting.requestPeriod_StartDate), moment.utc(setting.requestPeriod_EndDate), null, '[]')
                )
            )

            if (!validSetting) {
                error = { exists: true, message: t('billboard.noRequestsAvailable') };
                this.handleSnackbar('error', error.message, true);
                return;
            }

            if (selectedActionIndex !== -1) {
                const selectedSetting = billboardActions[selectedActionIndex];
                const validation = filteredManagerSettings.find(setting => setting.id === selectedSetting.value).workedHoursValidation
                if (validation && !validation.isValid) {
                    error = {
                        exists: true,
                        message: `Worked hours requirements not met. Required time worked between ${formatAs(validation.startDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}
                        and ${formatAs(validation.endDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)} is ${validation.requiredHours} hours. Hours worked during that period: ${validation.workedHours}
                        `
                    }
                }
                if (selectedShifts.length >= 1 && !selectedShifts.find(x => x.id === schedule.raw.id) && !selectedSetting.isAllowMultipleRequests) {
                    error = {
                        exists: true,
                        message: `This request does not allow multiple requests`
                    }
                }
            }
        }
        if (error.exists) {
            this.handleSnackbar('error', error.message, true)
        } else {
            new Promise((resolve, reject) => {
                selectShift(schedule.raw)
                resolve()
            }).then(() => {
                let filteredManagerSettings = managerSettings.filter(setting => setting.isVisible
                    && ![RequestTypes.openShift, RequestTypes.voluntaryTimeOff].includes(setting.type))
                filteredManagerSettings = this.findValidSettingsToSelectedShifts(filteredManagerSettings)

                this.setState({
                    billboardActions: UI.generateBillboardActions(filteredManagerSettings),
                })
            })
        }
    }

    handleLoadToCoverOffers = async (dates, spinner = true) => {
        let errMsg = await this.props.handleLoadToCoverOffers(dates, spinner);
        if (errMsg) {
            this.handleSnackbar('error', errMsg, true);
        }
    }

    fetchExtraDetails = async (offerId, requestType) => {
        const { options } = this.props;
        var extraDetails = undefined;

        this.props.updateLoading(true);
        await Net.GetExtraDetails(options, offerId, requestType).then(async response => {
            extraDetails = response.data;
            this.props.updateLoading(false);
        }).catch(err => {
            let message = aux.handleAPIErrors(err.response)
            this.props.updateSnackbar({
                typeSnackbar: 'error',
                messageSnackbar: message,
                openSnackbar: true,
            })
        });

        return extraDetails;
    }

    handleShiftClick = async (event, isNonSchedule = false) => {
        const { managerSettings, managerSettingNames, storeData, options, person, updateSidePanelData, selectedActionIndex, updateSelectedActionIndex } = this.props
        const { billboardActions, userCurrentOffset } = this.state;
        let data = {};
        let orgJob = Utils.parseJobAndLocation(person.primaryJob);
        let error = { exists: false, message: '' };
        const currentTime = getCurrentUkgUserDateTime(new Date()).toISOString();

        const shiftStartTime = removeUkgUserTimeZoneTransformation(new Date(event.schedule.raw.startDateTime));
        const hasShiftStarted = event.schedule.raw.startDateTime < currentTime;
        const hasShiftEnded = event.schedule.raw.endDateTime < currentTime;
        const isShiftInProgress = hasShiftStarted && !hasShiftEnded;
        const validManagerSettingsAfterShiftStart = managerSettings.filter(x => Utils.isValidSettingAfterShiftStart(x, shiftStartTime));
        if (hasShiftEnded || (isShiftInProgress && !validManagerSettingsAfterShiftStart.length) && !isNonSchedule && event.schedule.calendarId === "0") {
            this.handleSnackbar('error', 'Shift is in the past', true);
            return
        }

        switch (event.schedule.calendarId) {
            case '0':
                // Do not allow click if it's already in the available cover (non partial or partial non multiple or multiple partial > 2
                const newRequestBlockedResult = getSettingsOfExistingOffersBlockingNewRequest(storeData, event.schedule.id);
                if (newRequestBlockedResult.isNewRequestBlocked) {
                    error = UI.generateMultiSettingActionErrorMessage(newRequestBlockedResult.blockingManagerAggregateRootIds, managerSettings);
                    break;
                }

                let shift = event.schedule.raw

                let filteredManagerSettings;

                filteredManagerSettings = managerSettings.filter(setting =>
                    setting.isVisible &&
                    (setting.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                        || moment.utc().add(userCurrentOffset, 'm').isBetween(moment.utc(setting.toCoverPeriod_StartDate), moment.utc(setting.toCoverPeriod_EndDate), null, '[]'))
                    && Utils.isDatetimeInRequestPeriod(shift.startDateTime, setting)
                    && ![RequestTypes.openShift, RequestTypes.voluntaryTimeOff].includes(setting.type)
                )

                if (isShiftInProgress) {
                    const validManagerSettingsAfterShiftStartIds = validManagerSettingsAfterShiftStart.map(x => x.id);
                    filteredManagerSettings = filteredManagerSettings.filter(x => validManagerSettingsAfterShiftStartIds.includes(x.id));
                }

                if (newRequestBlockedResult.multiplePartialCount > 0) {//Can only be offered as multiple partial
                    filteredManagerSettings = filteredManagerSettings.filter(x => x.isPartialShiftEnabled && x.isMultiplePartialEnabled)
                }

                filteredManagerSettings = Utils.getValidManagerSettings(filteredManagerSettings, [event.schedule.raw]);
                if (filteredManagerSettings.length === 0) {
                    error = { exists: true, message: this.props.t('billboard.noRequestsAvailable') };
                    break;
                }

                if (selectedActionIndex !== -1) {
                    const validation = filteredManagerSettings.find(setting => setting.id === billboardActions[selectedActionIndex].value).workedHoursValidation
                    if (validation && !validation.isValid) {
                        error = {
                            exists: true,
                            message: `Worked hours requirements not met. Required time worked between ${formatAs(validation.startDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}
                            and ${formatAs(validation.endDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)} is ${validation.requiredHours} hours. Hours worked during that period: ${validation.workedHours}
                            `
                        }
                        break
                    }
                }

                let listOfShifts = [shift];

                let selectedPartialLabel = generateSelectedPartialLabel(listOfShifts[0], listOfShifts[0].startDateTime, listOfShifts[0].endDateTime, RequestTypes.toCover)
                updateSelectedActionIndex(-1)
                this.setState({
                    billboardActions: UI.generateBillboardActions(filteredManagerSettings),
                    selectedPartialLabel: selectedPartialLabel,
                    partialDates: {
                        startDate: listOfShifts[0].startDateTime,
                        endDate: listOfShifts[0].endDateTime
                    }
                })
                data = {
                    type: -1,
                    label: 'Employee Request',
                    shifts: listOfShifts,
                    employeeName: person.personName,
                    location: orgJob.location,
                    job: orgJob.job,
                }
                break;
            case '1': // Paycodes. Do nothing
                break;
            default:
                let rawData = event.schedule.raw;
                let setting
                if (rawData.type === RequestTypes.openShift && rawData.isAvailableOffer) {
                    setting = managerSettings.find(setting => rawData.managerSettingIds.includes(setting.id))
                } else {
                    setting = managerSettings.find(setting => setting.id === rawData.managerSettingId)
                }

                switch (setting.type) {
                    case RequestTypes.toCover: {

                        const extraData = await this.fetchExtraDetails(rawData.offerId, 0);

                        if (rawData.isPartial) {
                            data = UI.buildUIShift(rawData.offerId, rawData.status, [rawData.partialShift], orgJob, rawData.employeeFromName, setting.name, rawData.source, setting.type, extraData.history, setting.details)
                        } else if (event.schedule.isBackendRequestBodyStillCorrect) {
                            data = UI.buildUIShift(rawData.offerId, rawData.status, rawData.shifts, orgJob, rawData.employeeFromName, setting.name, rawData.source, setting.type, extraData.history, setting.details, null, rawData.isValid, rawData.rawValidationDetails, rawData.statusValidationDetails)
                        } else {
                            data = UI.buildUIShift(rawData.offerId, rawData.status, [rawData.shift], orgJob, rawData.employeeFromName, setting.name, rawData.source, setting.type, extraData.history, setting.details)
                        }
                        data = { ...data, raw: rawData, extra: extraData }
                        if (rawData.status === RequestStatus.Offered) {
                            data.restrictionDates = extraData.restrictionDates;
                        }
                        break;
                    }
                    case RequestTypes.shiftSwap: {

                        const extraData = await this.fetchExtraDetails(rawData.offerId, 1);

                        const myProposal = storeData.myProposals.find(x => x.offerId === rawData.offerId)
                        let allMyProposals = myProposal ? myProposal.proposals : rawData.proposals
                        allMyProposals = allMyProposals ? allMyProposals : []

                        const allMyProposalAutoRetracted = allMyProposals.length && allMyProposals.every(x => x.status === RequestStatus.AutoRetracted);
                        if (allMyProposalAutoRetracted && rawData.offerorEmployeeId !== person.currentEmployeeId) {
                            rawData.status = RequestStatus.AutoRetracted;
                        }

                        if (rawData.source === RequestSource.Requester
                            && rawData.status === RequestStatus.Offered
                            && !allMyProposals.some(x => ongoingRequestStatuses.includes(x.status))) {
                            // Parse proposal history.

                            await this.fetchAndUpdateShifts(rawData.offerId);

                        }

                        let shiftSwapShift = rawData.shifts;
                        if (rawData.isPartial) {
                            shiftSwapShift = [rawData.partialShift];
                        }

                        data = UI.buildUIShift(rawData.offerId, rawData.status, shiftSwapShift, orgJob, rawData.offerorEmployeeName, setting.name, rawData.source, setting.type, extraData.history, setting.details, rawData.proposals, rawData.isValid, rawData.rawValidationDetails, rawData.statusValidationDetails)
                        data = { ...data, raw: rawData };
                        if (rawData.status === RequestStatus.Offered) {
                            data.restrictionDates = extraData.restrictionDates;
                        }
                        break;
                    }
                    case RequestTypes.openShift: {
                        const setting = managerSettings.find(x => x.id === rawData.managerSettingId)
                        if (rawData.source === RequestSource.Requester) {
                            // Available open shifts
                            data = {
                                type: RequestTypes.openShift,
                                offerId: rawData.key,
                                label: managerSettingNames[rawData.managerSettingId],
                                shifts: [rawData.shifts[0]],
                                location: orgJob.location,
                                job: orgJob.job,
                                source: rawData.source,
                                raw: [rawData],
                                isValid: true,
                                requestSubtype: setting?.requestSubtype,
                                isPartialShiftEnabled: setting.isPartialShiftEnabled,
                            }

                            // Check if advanced option
                            if (setting?.requestSubtype === RequestSubtypes.signUp) { // Advanced available OS (with awarding system)
                                data = {
                                    ...data,
                                    managerSetting: setting,
                                    details: setting.details,
                                }
                            }
                        } else {
                            // Open shift requests
                            const extraData = await this.fetchExtraDetails(rawData.id, 2);
                            let shift = null;
                            if (rawData.isPartial) {
                                shift = [rawData.partialShift];
                            }
                            else {
                                shift = [rawData.shift];
                            }

                            data = {
                                ...UI.buildUIShift(
                                    rawData.id,
                                    rawData.status,
                                    shift,
                                    orgJob,
                                    null,
                                    setting.name,
                                    rawData.source,
                                    setting.type,
                                    extraData.history,
                                    setting.details,
                                ),
                                isPartial: rawData.isPartial,
                                submissionPeriod: extraData.submissionPeriodDates,
                            };
                        }

                        break;
                    }
                    case RequestTypes.voluntaryTimeOff: {
                        rawData = isNonSchedule ? {
                            ...rawData,
                            distribution: rawData.timeOffDistribution
                        } : rawData
                        switch (rawData.source) {
                            case RequestSource.Offerer:
                                const extraData = await this.fetchExtraDetails(rawData.offerId, 3);

                                data = {
                                    type: RequestTypes.voluntaryTimeOff,
                                    offerId: rawData.offerId,
                                    label: managerSettingNames[rawData.managerSettingId],
                                    source: rawData.source,
                                    raw: rawData,
                                    status: rawData.status,
                                    isValid: rawData.isValid,
                                    history: extraData.history,
                                    managerSetting: setting,
                                    details: rawData.details,
                                    isPartial: rawData.isPartial,
                                    partialStartDate: rawData.partialStartDate,
                                    partialEndDate: rawData.partialEndDate,
                                }
                                break
                            case RequestSource.Requester:
                                if (moment.utc().add(userCurrentOffset, 'm').isBetween(moment.utc(rawData.submissionStartDate), moment.utc(rawData.submissionEndDate), null, '[]')) {
                                    if (!moment.utc().add(userCurrentOffset, 'm').isAfter(moment.utc(rawData.timeOffStartDate))) {
                                        const setting = managerSettings.find(x => x.id === rawData.managerSettingId)
                                        data = {
                                            type: RequestTypes.voluntaryTimeOff,
                                            requestSubtype: setting?.requestSubtype,
                                            offerId: rawData.offerId,
                                            label: managerSettingNames[rawData.managerSettingId],
                                            source: rawData.source,
                                            raw: rawData,
                                            status: rawData.status,
                                            isValid: rawData.isValid,
                                            managerSetting: setting,
                                            details: rawData.details,
                                            isPartialShiftEnabled: setting.isPartialShiftEnabled,
                                        }
                                    }
                                    else {
                                        error.exists = true
                                        error.message = `Selected VTO is affecting a shift in the past`
                                    }
                                } else {
                                    error.exists = true
                                    error.message = `Outside of subscription period for the selected VTO`
                                }
                                break
                            default:
                                break;
                        }
                        break;
                    }
                    default:
                        break;
                }
        }
        if (error.exists) {
            this.handleSnackbar('error', error.message, true)
        } else {
            updateSidePanelData(data)
        }
    }

    handleSnackbar = (type, message, openState) => {
        this.props.updateSnackbar({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    closeSnackbar = () => {
        this.props.updateSnackbar({
            typeSnackbar: 'success',
            messageSnackbar: '',
            openSnackbar: false
        })
    }

    containerHandler = () => {
        this.setState({ open: !this.state.open })
    }

    handleNextOrPrevView = (index) => {
        const { currentMonth, currentView } = this.state;
        let updatedCurrentMonth = currentMonth.toDate();
        if (currentView.value === BillboardViewType.Calendar) {
            const calendarRef = this.calendarRef.current.getInstance();
            if (currentView.label === "Monthly") {
                updatedCurrentMonth.setDate(1);
                if (index === 1) {
                    updatedCurrentMonth = new Date(updatedCurrentMonth.setMonth(updatedCurrentMonth.getMonth() + 1));
                }
                else if (index === -1) {
                    updatedCurrentMonth = new Date(updatedCurrentMonth.setMonth(updatedCurrentMonth.getMonth() - 1));
                }
                calendarRef.setDate(updatedCurrentMonth);
                this.setState({
                    currentMonth: moment.utc(calendarRef.getDate().toDate())
                })
            }
            else if (currentView.label === "Weekly") {
                if (index === 1) {
                    calendarRef.next();
                } else if (index === -1) {
                    calendarRef.prev();
                }
                this.setState({
                    currentMonth: moment.utc(calendarRef.getDate().toDate())
                })
            }
            if (!currentMonth.isSame(moment.utc(calendarRef.getDate().toDate()), 'month'))
                this.updateDateRange(calendarRef.getDate().toDate())
        }
        else if (this.state.currentView.value === BillboardViewType.List) {
            if (index === 1) {
                updatedCurrentMonth = new Date(updatedCurrentMonth.setMonth(updatedCurrentMonth.getMonth() + 1));
            }
            else if (index === -1) {
                updatedCurrentMonth = new Date(updatedCurrentMonth.setMonth(updatedCurrentMonth.getMonth() - 1));
            }
            this.setState({
                currentMonth: moment.utc(updatedCurrentMonth)
            })
            this.updateDateRange(moment.utc(updatedCurrentMonth))
        }
    }

    handleOpenNotifications = () => {
        const { storeData } = this.props;
        let loadData = () => { };
        if (!storeData.privateOffersSummary.loadedIds.length) {
            loadData = () => {
                this.props.updateLoading(true)
                Handlers.loadNextNotifications.bind(this)(false);
            }
        }

        this.setState({
            showNotificationPanel: true
        }, loadData())
    }

    findValidSettingsToSelectedShifts = (managerSettings) => {
        const { selectedShifts } = this.props
        const { userCurrentOffset } = this.state;
        const currentTime = getCurrentUkgUserDateTime(new Date()).toISOString();

        let validSettings = managerSettings.filter(setting => (setting.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever ||
            moment.utc().add(userCurrentOffset, 'm').isBetween(moment.utc(setting.toCoverPeriod_StartDate), moment.utc(setting.toCoverPeriod_EndDate), null, '[]')));
        for (const shift of selectedShifts) {
            const shiftStartTime = getCurrentUkgUserDateTime(shift.startDateTime);
            const hasShiftStarted = shift.startDateTime < currentTime;
            const hasShiftEnded = shift.endDateTime < currentTime;
            const isShiftInProgress = hasShiftStarted && !hasShiftEnded;
            validSettings = validSettings.filter(setting => Utils.isDatetimeInRequestPeriod(shift.startDateTime, setting) &&
                !hasShiftEnded &&
                (!isShiftInProgress || Utils.isValidSettingAfterShiftStart(setting, shiftStartTime)))
        }
        return validSettings;
    }

    refreshManagerSettings = async (callback = () => { }) => {
        const { billboardActions, userCurrentOffset } = this.state;
        const { managerSettings, dateRanges, selectedOpenShifts, selectedActionIndex, updateSelectedActionIndex, generateCalendarDefinitionAndFilters, storeData } = this.props

        let settings = managerSettings
        // if shift multi select is active
        let actionIndex = selectedActionIndex

        if (selectedOpenShifts.length > 0) {
            for (const shift of selectedOpenShifts) {
                settings = settings.filter(setting => Utils.isDatetimeInRequestPeriod(shift.startDateTime, setting)
                    && setting.type === RequestTypes.openShift
                    && setting.id === selectedOpenShifts[0].managerSettingId
                )
            }
        } else {
            settings = this.findValidSettingsToSelectedShifts(settings)
        }
        generateCalendarDefinitionAndFilters(settings, storeData.monthlySchedule);

        let newBillboardActions = UI.generateBillboardActions(settings.filter(setting =>
            setting.isVisible
            && ![RequestTypes.openShift, RequestTypes.voluntaryTimeOff].includes(setting.type)
            && (setting.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                || moment.utc().add(userCurrentOffset, 'm').isBetween(moment.utc(setting.toCoverPeriod_StartDate), moment.utc(setting.toCoverPeriod_EndDate), null, '[]'))
            && (
                (setting.requestPeriod_TypeOfPeriod === TypeOfPeriod.Forever && setting.requestPeriodLimitInDays === null)
                || moment.utc(setting.requestPeriod_StartDate).isBetween(moment.utc(dateRanges.startDate), moment.utc(dateRanges.endDate), null, '[]')
                || moment.utc(setting.requestPeriod_EndDate).isBetween(moment.utc(dateRanges.startDate), moment.utc(dateRanges.endDate), null, '[]')
                || (
                    moment.utc(dateRanges.startDate).isBetween(moment.utc(setting.requestPeriod_StartDate), moment.utc(setting.requestPeriod_EndDate), null, '[]')
                    && moment.utc(dateRanges.endDate).isBetween(moment.utc(setting.requestPeriod_StartDate), moment.utc(setting.requestPeriod_EndDate), null, '[]')
                )
            )
        ))

        if (actionIndex !== -1 && !newBillboardActions.find(ele => ele.id === billboardActions[actionIndex].value))
            actionIndex = -1

        updateSelectedActionIndex(actionIndex)
        this.setState({
            billboardActions: newBillboardActions,
        }, () => callback)
    }

    handleRefreshButton = async () => {
        const { options, dateRanges } = this.props
        this.props.updateLoading(true)

        //clear selected checkboxes
        this.props.clearSelectedShifts();
        this.props.clearSelectedOpenShifts();

        // Clear existing manager settings to prevent duplicates
        this.props.clearManagerSettings();

        // Reload manager settings in parallel with month data
        const managerSettingsPromise = Net.getManagerSettings(dateRanges.startDate, dateRanges.endDate, options)
            .then(async managerSettingsResponse => {
                let managerSettings = managerSettingsResponse.data
                await this.props.appendManagerSettings(managerSettings)
            })
            .catch(err => {
                let message = aux.handleAPIErrors(err.response)
                this.props.updateSnackbar({
                    typeSnackbar: 'error',
                    messageSnackbar: message,
                    openSnackbar: true,
                })
            })

        // Reload all month data (shifts, paycodes, and requests) in parallel with manager settings
        // Pass managerSettingsPromise so refreshData waits for it before using manager settings
        await this.props.refreshData(true, managerSettingsPromise)

        // Update UI state after data is loaded
        this.refreshManagerSettings();
        this.props.updateLoading(false);
    }

    updateDateRange = async (date) => {
        this.props.updateLoading(true);
        const { startDate, endDate } = getMonthWeekRange(date, this.props.firstDayOfTheWeek);

        this.props.updateDateRange({
            startDate: startDate.format(Utils.MomentFormats.YMD),
            endDate: endDate.format(Utils.MomentFormats.YMD),
        })

        // Reload all month data (shifts, paycodes, and requests)
        // refreshData calls loadMonthData which handles everything
        await this.props.refreshData(false);

        // Update UI state after data is loaded
        this.refreshManagerSettings();
        this.props.updateLoading(false);
    }

    refreshOnlyManagerSettings = () => {
        const { managerSettings, dateRanges, userCurrentOffset } = this.props
        let newBillboardActions = UI.generateBillboardActions(managerSettings.filter(setting =>
            setting.isVisible
            && ![RequestTypes.openShift, RequestTypes.voluntaryTimeOff].includes(setting.type)
            && (setting.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                || moment.utc().add(userCurrentOffset, 'm').isBetween(moment.utc(setting.toCoverPeriod_StartDate), moment.utc(setting.toCoverPeriod_EndDate), null, '[]'))
            && (
                (setting.requestPeriod_TypeOfPeriod === TypeOfPeriod.Forever && setting.requestPeriodLimitInDays === null)
                || moment.utc(setting.requestPeriod_StartDate).isBetween(moment.utc(dateRanges.startDate), moment.utc(dateRanges.endDate), null, '[]')
                || moment.utc(setting.requestPeriod_EndDate).isBetween(moment.utc(dateRanges.startDate), moment.utc(dateRanges.endDate), null, '[]')
                || (
                    moment.utc(dateRanges.startDate).isBetween(moment.utc(setting.requestPeriod_StartDate), moment.utc(setting.requestPeriod_EndDate), null, '[]')
                    && moment.utc(dateRanges.endDate).isBetween(moment.utc(setting.requestPeriod_StartDate), moment.utc(setting.requestPeriod_EndDate), null, '[]')
                )
            )
        ))
        this.setState({
            billboardActions: newBillboardActions,
        }, () => { })
    }

    fetchAndUpdateShifts = async (offerId, isSkipValidation = false) => {
        this.props.updateLoading(true);
        await Net.getMyShiftsToPropose(this.props.options, offerId, isSkipValidation)
            .then(shiftResponse => {
                this.props.updateValidProposalShifts(shiftResponse.data.shifts);
            })
            .catch(ex => {
                const message = aux.handleAPIErrors(ex.response);
                this.handleSnackbar('error', message, true);
            })
        this.props.updateLoading(false);
    }

    render() {
        const {
            classes,
            firstDayOfTheWeek,
            globalHistory,
            managerSettingNames,
            managerSettingsLoaded,
            person,
            buildInfos,
            refreshData,
            selectedActionIndex,
            selectedShifts,
            statusDictionary,
            storeData,
            t,
            selectedOpenShifts,
        } = this.props;


        const {
            billboardActions,
            open,
            openActionOptions,
            showNotificationPanel,
            tabSelected,
            currentView,
            currentMonth,
        } = this.state;

        const validBillboardActions = Utils.getValidManagerSettings(billboardActions, selectedShifts);
        return (
            <Grid container className={classes.fullPage}>
                <TopBar
                    person={person}
                    buildInfos={buildInfos}
                >
                    <div className={classes.appName}>
                        <Typography variant="h5" >Employee Billboard</Typography>
                    </div>
                    <div className={clsx(classes.flex, classes.topBar)}>
                        <Button onClick={this.handleRefreshButton} className={clsx(classes.button, classes.refreshButton)}><FontAwesomeIcon icon={faSync} /></Button>
                        <div ref={this.actionButtonRef}>
                            <SplitButton
                                disabled={!managerSettingsLoaded || (selectedShifts.length === 0 && selectedOpenShifts.length === 0)}
                                options={validBillboardActions}
                                open={openActionOptions}
                                selectedIndex={selectedActionIndex}
                                size='medium'
                                color='primary'
                                handleClick={this.handleActionRequest}
                                handleMenuItemClick={(event, index) => this.handleOpenActionType(event, index, validBillboardActions, billboardActions)}
                                handleToggle={this.handleActionOptionToggle}
                                handleClose={this.handleActionOptionClose}
                                className={classes.ButtonAction}
                                placeholder={managerSettingsLoaded ? t('billboard.newRequest') : t('billboard.splitBtnLoading')}
                                paperStyles={{
                                    minWidth: '230px',
                                    width: 'fit-content',
                                    maxHeight: '30vh',
                                    overflowY: 'auto',
                                }}
                            />
                        </div>
                        <SplitButton
                            options={this.state.calendarViewOptions}
                            open={this.state.openCalendarViewOptions}
                            selectedIndex={this.state.selectedCalendarIndex}
                            size='medium'
                            color='secondary'
                            handleMenuItemClick={this.handleCalendarType}
                            handleToggle={this.handleCalendarViewOptionToggle}
                            handleClose={this.handleCalendarViewOptionClose}
                            className={classes.ButtonAction}
                        />
                        <Button onClick={() => this.handleNextOrPrevView(-1)} className={clsx(classes.button, classes.arrowButton)}><FontAwesomeIcon icon={faAngleLeft} /></Button>
                        <Button onClick={() => this.handleNextOrPrevView(1)} className={clsx(classes.button, classes.arrowButton)}><FontAwesomeIcon icon={faAngleRight} /></Button>
                        <Typography>
                            {
                                currentView.label === "Weekly"
                                    ? moment.utc(currentMonth).day(firstDayOfTheWeek).format(Utils.MomentFormats.MMMDD) + ' - ' + moment.utc(currentMonth).day(firstDayOfTheWeek + 6).format(Utils.MomentFormats.MMMDD)
                                    : moment.utc(currentMonth).format(Utils.MomentFormats.MMMMYYYY)
                            }
                        </Typography>
                        <Button
                            aria-controls={open ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            onClick={this.handleOpenNotifications}
                        >
                            <Badge overlap="rectangular" badgeContent={storeData.privateOffersSummary.new} color="secondary">
                                {storeData.privateOffersSummary.new ? <NotificationsActiveIcon style={{ color: '#EE0F0F' }} /> : <NotificationsIcon />}
                            </Badge>
                        </Button>
                    </div>
                </TopBar>
                {showNotificationPanel ? <SideBar
                    handleDrawerClose={() => this.closeSidePanel()}
                    open={this.state.showNotificationPanel}
                    className={classes.SideBar}
                    title={<Typography className={classes.SideBarTitle}>{t('notifications.header')}</Typography>}
                    isCloseOnOutsideClick={false}
                >
                    <NotificationList
                        list={UI.standardizeNotificationList(person.currentEmployeeId, storeData.privateOffers, statusDictionary)}
                        managerSettingNames={managerSettingNames}
                        privateOffersSummary={storeData.privateOffersSummary}

                        handleViewButton={this.handleViewButton}
                        handleDismissButton={Handlers.handleDismissButton.bind(this)}
                        handleDismissAllButton={Handlers.handleDismissAllButton.bind(this)}
                        handleLoadMoreButton={Handlers.loadNextNotifications.bind(this)}
                    />
                </SideBar> : null}
                <SidePanel
                    billboardActions={billboardActions}
                    refreshData={refreshData} // TODO KATH 5/3: is this used? can it be removed?
                    refreshManagerSettings={this.refreshOnlyManagerSettings}
                    fetchAndUpdateShifts={this.fetchAndUpdateShifts}
                />
                <Grid container id={'eeBillboard'} className={classes.mainContent}>
                    <PanelContainer
                        isOpen={open}
                        onTabChange={this.handleChange}
                        handleLoadToCoverOffers={this.handleLoadToCoverOffers}
                        managerSettingNames={managerSettingNames}
                        tabSelected={tabSelected}
                        globalHistory={globalHistory}
                        _this={this}
                        classes={classes}
                    />
                    <BillboardContainer open={open} id="calendarContainer">
                        {this.state.currentView.value === BillboardViewType.Calendar && (
                            <Grid item xs={1} sm={1} className={classes.flex}>
                                <Button onClick={() => this.containerHandler()} className={clsx(classes.button, classes.arrowButton)}>
                                    <FontAwesomeIcon icon={open ? ["fal", "arrow-to-left"] : ["fal", "arrow-to-right"]} />
                                </Button>
                            </Grid>
                        )}
                        {this.state.currentView.value === BillboardViewType.List && (
                            <BillboardListView
                                fillAvailableHeight
                                handleShiftClick={this.handleShiftClick}
                                handleMultiSelectShift={this.handleMultiSelectShift}
                                handleMultiSelectOpenShift={this.handleMultiSelectOpenShift}
                            />
                        )}
                        <div
                            className={
                                this.state.currentView.value === BillboardViewType.Calendar
                                    ? classes.calendarVisible
                                    : classes.calendarHidden
                            }
                        >
                            <Calendar
                                initLoad={this.props.managerSettingsLoaded || this.props.shiftsLoaded}
                                firstDayOfTheWeek={firstDayOfTheWeek}
                                calendarRef={this.calendarRef}
                                handleShiftClick={this.handleShiftClick}
                                updateDateRange={this.updateDateRange}
                                currentView={this.state.currentView.value}
                                handleMultiSelectShift={this.handleMultiSelectShift}
                                handleMultiSelectOpenShift={this.handleMultiSelectOpenShift}
                                visibleWeeksCount={this.state.calendarViewOptions[this.state.selectedCalendarIndex]['visibleWeeksCount']}
                                handleLoadToCoverOffers={this.handleLoadToCoverOffers}
                            />
                        </div>
                    </BillboardContainer>
                </Grid>
                <Snackbar
                    type={this.props.snackbar.typeSnackbar}
                    message={this.props.snackbar.messageSnackbar}
                    open={this.props.snackbar.openSnackbar}
                    bodyStyle={{ whiteSpace: 'pre-line' }}
                    closeSnackbar={this.closeSnackbar}
                />
            </Grid>
        )
    }
}
const mapStateToProps = (state) => ({
    calendar: state.calendar,
    dateRanges: state.dateRanges,
    employeeShiftOffers: state.data.employeeShiftOffers,
    filtersDefinition: state.filters,
    globalHistory: state.data.globalHistory,
    loading: state.loadingState,
    managerSettingNames: state.managerSettingNames,
    managerSettings: state.managerSettings,
    options: state.httpOptions,
    person: state.person,
    buildInfos: state.buildInfos,
    refreshedDates: state.refreshedDates,
    selectedActionIndex: state.selectedActionIndex,
    selectedOpenShifts: state.selectedOpenShifts,
    selectedShifts: state.selectedShifts,
    snackbar: state.snackbar,
    statusDictionary: state.statusDictionary,
    storeData: state.data,
});

const mapDispatchToProps = dispatch => ({
    selectShift: (payload) => dispatch(selectShift(payload)),
    clearSelectedShifts: () => dispatch(clearSelectedShifts()),
    clearSelectedOpenShifts: () => dispatch(clearSelectedOpenShifts()),
    selectOpenShift: (payload) => dispatch(selectOpenShift(payload)),
    updateFilterList: (payload) => dispatch(updateFilterList(payload)),
    updateLoading: (payload) => dispatch(updateLoading(payload)),
    updateSnackbar: (payload) => dispatch(updateSnackbar(payload)),
    updateDateRange: payload => dispatch(updateDateRange(payload)),
    updateEmployeeDashboardData: payload => dispatch(updateEmployeeDashboardData(payload)),
    appendManagerSettings: payload => dispatch(appendManagerSettings(payload)),
    clearManagerSettings: () => dispatch(clearManagerSettings()),
    updateSidePanelData: payload => dispatch(updateSidePanelData(payload)),
    updateEmployeeToOfferList: payload => dispatch(updateEmployeeToOfferList(payload)),
    updateSelectedActionIndex: payload => dispatch(updateSelectedActionIndex(payload)),
    updateValidProposalShifts: payload => dispatch(updateValidProposalShifts(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EmployeeDashboardStyles)(withTranslation('employmentBillboard')(EmployeeDashboard)))
